import ExpandableButton from '@commons/expandable-button/ExpandableButton'
import SectionHeader from '@commons/section-header/SectionHeader'
import styles from './Card.module.scss'
import { Link } from '@nespresso-design-system/components'
import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker'
import { useRef } from 'preact/hooks'
import ModalTrigger from '@commons/enhanced-modal/ModalTrigger.tsx'

const Card = ({
    cta,
    image,
    sub_heading,
    heading,
    onClick,
    btnRef,
    link,
    campaign,
    promotion_details,
    onOpenModal
}) => {
    const containerRef = useRef(null)

    useImpressionTracker(containerRef, campaign)

    return (
        <div className={styles.container}>
            <div className={styles.mediaContainer}>
                <picture>
                    {image?.retina?.src && (
                        <source
                            srcSet={image?.retina?.src}
                            media="(min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2), (min-width: 1024px) and (min-resolution: 192dpi)"
                        />
                    )}
                    {image?.desktop?.src && (
                        <source
                            srcSet={image?.desktop?.src}
                            media="(min-width: 768px)"
                        />
                    )}
                    {image?.mobile?.src && (
                        <source
                            srcSet={image?.mobile?.src}
                            media="(max-width: 767px)"
                        />
                    )}
                    <img
                        src={
                            image?.desktop?.src ||
                            image?.mobile?.src ||
                            image?.retina?.src
                        }
                        alt={
                            image?.desktop?.alt ||
                            image?.mobile?.alt ||
                            image?.retina?.alt
                        }
                    />
                </picture>
            </div>

            {/* Overlay */}
            <div className={styles.overlay}>
                <div className={styles.header}>
                    <SectionHeader
                        alignMobile="left"
                        headline={heading}
                        subhead={sub_heading}
                        contrast="dark"
                        small
                    />
                </div>
                <div className={styles.footer}>
                    <ExpandableButton
                        {...cta}
                        onClick={onClick}
                        link={cta.link}
                        ref={btnRef}
                        config={{ iconPosition: 'leading' }}
                        variant={cta.config.variant || 'secondary'}
                        contrast={cta.contrast || 'light'}
                        icon={cta.config.icon ?? '24/symbol/chevron-right'}
                    />

                    {promotion_details?.promo_link?.label && !link.label ? (
                        <ModalTrigger
                            onClick={() => {
                                onOpenModal(promotion_details)
                            }}
                            {...promotion_details.promo_link}
                            promo_link={{
                                ...promotion_details.promo_link,
                                config: {
                                    ...promotion_details.promo_link.config,
                                    className: styles.link,
                                    hasUnderline: true
                                }
                            }}
                        />
                    ) : (
                        <Link
                            {...link}
                            variant="white"
                            className={styles.link}
                            hasUnderline={true}
                            size={'small'}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default Card
